import { Component } from '@angular/core';

@Component({
  selector: 'app-dollar-icon',
  templateUrl: './dollar-icon.component.html',
  styleUrl: './dollar-icon.component.scss'
})
export class DollarIconComponent {

}
